import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import ChatBot from "./components/ChatBot";
import LandingPage from "./pages/LandingPage";
import ApplyPage from "./pages/ApplyPage";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import CommissionPlans from "./pages/CommissionPlans";
import WhyJoinKrieger from "./pages/WhyJoinKrieger";
import AgentIncomeCalculator from "./pages/AgentIncomeCalculator";
import JobsNYC from "./pages/JobsNYC";
import JobsPhiladelphia from "./pages/JobsPhiladelphia";
import JobsMiami from "./pages/JobsMiami";
import BlogPage from "./pages/BlogPage";
import BlogPost from "./pages/BlogPost";
import ApplicationStatus from "./pages/ApplicationStatus";
import ListingPage from "./pages/ListingPage";
import AgentWebsite from "./pages/AgentWebsite";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions - session_id must be processed BEFORE ProtectedRoute runs
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isDashboard = location.pathname.startsWith('/dashboard');
  const isAdmin = location.pathname.startsWith('/admin');
  const isPayment = location.pathname.startsWith('/payment');
  const isAgentSite = location.pathname.startsWith('/agent/');

  return (
    <>
      {!isDashboard && !isAdmin && !isPayment && !isAgentSite && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/commission-plans" element={<CommissionPlans />} />
        <Route path="/why-join-krieger" element={<WhyJoinKrieger />} />
        <Route path="/agent-income-calculator" element={<AgentIncomeCalculator />} />
        <Route path="/real-estate-agent-jobs-nyc" element={<JobsNYC />} />
        <Route path="/real-estate-agent-jobs-philadelphia" element={<JobsPhiladelphia />} />
        <Route path="/real-estate-agent-jobs-miami" element={<JobsMiami />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/application-status" element={<ApplicationStatus />} />
        <Route path="/listing/:slug" element={<ListingPage />} />
        <Route path="/agent/:slug" element={<AgentWebsite />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment/success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAdmin && !isPayment && !isAgentSite && <ChatBot />}
    </>
  );
}

function App() {
  useEffect(() => {
    const remove = () => { const el = document.getElementById('emergent-badge'); if (el) el.remove(); };
    remove();
    const obs = new MutationObserver(remove);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
